export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms))

export const withMinLoadingTime = async <T>(
  asyncFunction: () => Promise<T>,
  minTime = 1000
) => {
  const startTime = Date.now()

  const result = await asyncFunction()

  const elapsed = Date.now() - startTime
  if (elapsed < minTime) {
    await new Promise((resolve) => setTimeout(resolve, minTime - elapsed))
  }

  return result
}
